import { motion } from 'framer-motion';

export function CareerEntry({ company, period, role, children }) {
  return (
    <motion.div
      className="bg-card/40 border border-border/20 rounded-xl p-6"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
    >
      <div className="flex flex-wrap items-center gap-3 mb-2">
        <h3 className="text-lg font-bold text-white">{company}</h3>
        <span className="text-sm text-primary font-medium">{period}</span>
      </div>
      {role && <p className="text-sm text-slate-400 italic mb-3">{role}</p>}
      {children}
    </motion.div>
  );
}
